import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack, FileCopyOutlined } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose, duplicate, configId }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton
        fontSize='medium'
        color='transparent'
        tooltip={t('Tooltips.AccountStatement.Duplicate')}
        onClick={()=>duplicate({ variables: { configId } })}
        disabled={!configId}
      >
        <FileCopyOutlined color={configId ? 'primary' : 'disabled'} />
      </IconButton>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.AccountStatement.BackToList')} onClick={onClickClose}>
        <ArrowBack />
      </IconButton>
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  duplicate: PropTypes.func.isRequired,
  configId: PropTypes.number
};

export default HeaderLinks;
